/**
 * @created : 2021/3/26
 * @author  : 王冲
 * @desc    : 邀请
 */

import { request } from "@weapp/utils";

//提交邀请
export const saveInvitees = (data: any) => {
  return request({
    url: `/api/basicserver/saves`,
    method: "post",
    data,
  });
};
//获取UUID
export const getUuid = () => {
  return request({
    url: `/api/basicserver/account/qureyKeyByUuid`,
    method: "post",
  });
};

/**
 * 检验是否绑定手机号
 */
export const checkUserMobileBind = () => {
  return request({
    url: `/api/basicserver/invite/checkUserMobileBind`,
    method: "GET"
  });
};

/**
 * 检验是否绑定邀请手机号
 */
export const checkUserInviteMobileBind = () => {
  return request({
    url: `/api/basicserver/invite/checkBindInviteMobile`,
    method: "GET"
  });
};


// 获取登录账号类型
export const qryLoginType = () => {
  return request({
    url: `/api/basicserver/safetysetting/selectAccountMode`,
    method: "GET",
  });
};

// 获取邀请人员的入职状态
export const qryPersonelStatus = () => {
  return request({
    url: `/api/basicserver/usersimport/getPersonalStatus`,
    method: "GET",
  });
};
